import { t } from '../lib/i18n'
import type { Health } from '../App'

/**
 * Beta must be impossible to mistake for production.
 *
 * Not a subtle badge in a corner: a full-width bar. Someone testing a
 * destructive action in what they believe is beta is the failure this prevents.
 */
export default function EnvBanner({ health }: { health: Health | null }) {
  if (!health || health.environment === 'production') return null
  return (
    <div className={`env env-${health.environment}`} role="status">
      {health.environment === 'beta' ? t('env.beta') : t('env.local')} · {health.commit}
    </div>
  )
}
